// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ProspectService = {}; 

ProspectService.getProspectList = function (userInput) { 
  var userInputIndex = userInput.pageIndex || 0;
   
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
 
  return lossClient({
    url:
      "/inputprospect/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&prospectId=" +
      userInput.prospectId +
      "&name=" +
      userInput.name +
      "&startDate=" +
      userInput.startDate +
      "&endDate=" +
      userInput.endDate +
      "&branchId=" +
      userInput.branchId,
    method: "get",
  });
};

ProspectService.getCalculateContract = function (userInput) { 

  return lossClient({
    url:
      "/InputProspect/calculateendcontract?birthDate=" +
      userInput.birthDate +
      "&tenor=" +
      userInput.tenor,
    method: "get",
  });
};

ProspectService.getCalculateAge = function (userInput) {

  return lossClient({
    url: "/InputProspect/calculatecurrentage?birthDate=" + userInput.birthDate,
    // +
    // "&tenor=" +
    // userInput.tenor,
    method: "get",
  });
};

ProspectService.postDeDupProspectList = function (data) {
  return lossClient({
    url: "/inputprospect/getCustomerData",
    method: "post",
    data: data,
  });
};

ProspectService.postProspect = function (data) {
  return lossClient({
    url: "/inputprospect/add",
    method: "post",
    data: data,
  });
};

ProspectService.updateProspect = function (data) {
  const { id, ...requestBody } = data;
  return lossClient({
    url: "/inputprospect/edit",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: requestBody,
  });
};

ProspectService.proceedProspect = function (data) {
  const { id, ...requestBody } = data;
  return lossClient({
    url: "/inputprospect/proceed",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: requestBody,
  });
};

ProspectService.cancelProspect = function (data) {
  const { id, ...requestBody } = data;
  return lossClient({
    url: "/inputprospect/cancel",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: requestBody,
  });
};

ProspectService.deleteProspect = function (data) {
  const { id, ...requestBody } = data;
  return lossClient({
    url: "/Prospect/delete",
    method: "delete",
    headers: {
      "x-requestId": data.id,
    },
    data: requestBody,
  });
};

export default ProspectService;
